import { Analytics, AnalyticsAdapterPlaceholder } from "@hotelchamp/common";

export const analytics = new Analytics({
    adapter: new AnalyticsAdapterPlaceholder(),
});
